export const FIRM_DOCUMENT_FILE_ACTION_DIALOG_TEST_IDS = {
  analyzeCancelButton: 'firm-documents-file-analyze-cancel-button',
  analyzeCloseButton: 'firm-documents-file-analyze-close-button',
  analyzeConfirmButton: 'firm-documents-file-analyze-confirm-button',
  analyzeDialog: 'firm-documents-file-analyze-dialog',
  analyzeDocumentList: 'firm-documents-file-analyze-document-list',
  copyCancelButton: 'firm-documents-file-copy-cancel-button',
  copyCloseButton: 'firm-documents-file-copy-close-button',
  copyConfirmButton: 'firm-documents-file-copy-confirm-button',
  copyDialog: 'firm-documents-file-copy-dialog',
  copyErrorMessage: 'firm-documents-file-copy-error-message',
  copyTargetMenu: 'firm-documents-file-copy-target-menu',
  copyTargetOption: (measurementDateId: number) => `firm-documents-file-copy-target-option-${measurementDateId}`,
  copyTargetSearch: 'firm-documents-file-copy-target-search',
  copyTargetSelect: 'firm-documents-file-copy-target-select',
  deleteCancelButton: 'firm-documents-file-delete-cancel-button',
  deleteCloseButton: 'firm-documents-file-delete-close-button',
  deleteConfirmButton: 'firm-documents-file-delete-confirm-button',
  deleteDialog: 'firm-documents-file-delete-dialog',
  downloadCancelButton: 'firm-documents-file-download-cancel-button',
  downloadCloseButton: 'firm-documents-file-download-close-button',
  downloadConfirmButton: 'firm-documents-file-download-confirm-button',
  downloadDialog: 'firm-documents-file-download-dialog',
  moveCancelButton: 'firm-documents-file-move-cancel-button',
  moveCloseButton: 'firm-documents-file-move-close-button',
  moveConfirmButton: 'firm-documents-file-move-confirm-button',
  moveDialog: 'firm-documents-file-move-dialog',
  moveErrorMessage: 'firm-documents-file-move-error-message',
} as const;
